import { handleHttp, transformStr3, getformdataList } from "@/utils/utils";
import Swiper from 'swiper';
export default {
  name: 'goldenCard',
  data() {
    return {
      cardList: [],
      primaryList: [],
      doc_width: '',
      doc_height: '',
      moveParams: {
        start_x: 0,
        start_y: 0,
        move_x: 1,
        move_y: 0,
        activeIndex: -1,
        moveDirection: ''
      },
      //拖动参数
      showSearch: false,
      //搜索框扩大
      searchList: [],
      //搜索数据列表
      initialsIndex: -1,
      primarySearchList: [],
      //搜索数据
      searchKey: '',
      scale: 1,
      isPc: false,
      pcTitleTop: 0,
      //pc标题高度
      swiperActiveIndex: 0 //轮播
    };
  },
  methods: {
    touchstart(e) {
      this.moveParams.move_x = 0;
      this.moveParams.start_x = e.touches[0].pageX;
      this.moveParams.start_y = e.touches[0].pageY;
      this.moveParams.activeIndex++;
      if (this.moveParams.activeIndex == this.cardList.length - 2) {
        this.cardList = this.cardList.concat(JSON.parse(JSON.stringify(this.primaryList)));
      }
    },
    touchmove(e) {
      this.moveParams.move_x = e.touches[0].pageX;
      this.moveParams.move_y = e.touches[0].pageY;
      this.moveParams.top_val = parseFloat(this.moveParams.move_y) - parseFloat(this.moveParams.start_y);
      this.moveParams.left_val = parseFloat(this.moveParams.move_x) - parseFloat(this.moveParams.start_x);
    },
    touchend(e) {
      this.moveParams.move_x = e.changedTouches[0].pageX;
      this.moveParams.move_y = e.changedTouches[0].pageY;
      if (this.moveParams.left_val > 0 && this.moveParams.left_val > this.doc_width / 2 - this.doc_width / 4.5) {
        this.moveParams.moveDirection = 1;
        this.moveParams.left_val = 0;
        this.moveParams.top_val = 0;
        setTimeout(() => {
          this.cardList[this.moveParams.activeIndex].hide = true;
          this.moveParams.moveDirection = '';
        }, 300);
      } else if (this.moveParams.left_val < 0 && this.moveParams.left_val < -this.doc_width / 2 + this.doc_width / 4.5) {
        this.moveParams.moveDirection = -1;
        this.moveParams.left_val = 0;
        setTimeout(() => {
          this.cardList[this.moveParams.activeIndex].hide = true;
          this.moveParams.moveDirection = '';
        }, 300);
      } else {
        //还原
        this.moveParams.activeIndex = this.moveParams.activeIndex - 1;
        this.moveParams.moveDirection = '';
        this.moveParams.left_val = 0;
      }
    },
    getData() {
      // 卡片列表
      this.$api.getFormList(this.$route.query.fid, '9a6697a0713df122f3b8041309697ddeaa5084d3028db91d73d6a5f2391a6610').then(res => {
        if (res.total > 0) {
          let list = res.data.map(item => {
            let itemformdata = item.formData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformdataList(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            return item;
          });
          this.primaryList = list;
          this.cardList = JSON.parse(JSON.stringify(list));
          if (this.isPc) {
            let that = this;
            this.$nextTick(() => {
              this.swiperItem = new Swiper('.swiper-container', {
                slidesPerView: 3,
                centeredSlides: true,
                spaceBetween: 100,
                loop: true,
                observer: true,
                observeParents: true,
                speed: 800,
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false
                },
                pagination: {
                  el: '.isPc .swiper-pagination'
                },
                on: {
                  slideChange: function () {
                    that.swiperActiveIndex = this.activeIndex;
                  }
                }
              });
            });
          }
        }
      });
    },
    // 跳转
    toUrl(url) {
      if (navigator.userAgent.toLowerCase().indexOf('chaoxingstudy') > -1) {
        jsBridge.postNotification('CLIENT_OPEN_URL', {
          'title': '',
          'loadType': '1',
          //打开方式，0在本页面打开，1使用客户端webview打开新页面，2打开系统浏览器
          'webUrl': url,
          'toolbarType': '2'
        });
        return;
      }
      window.open(url);
    },
    // 点击检索字母
    handelInitials(index) {
      this.initialsIndex = index - 1;
      if (index == 27) {
        this.$refs.searchList.scrollTo({
          top: this.$refs[`searchItem_${this.searchList.length - 1}`][0].offsetTop - 20,
          behavior: 'smooth'
        });
        return;
      }
      let listIndex = this.searchList.findIndex(s => {
        return makePy(s.itemformdata_s[1].charAt(0))[0].toUpperCase() >= String.fromCharCode(64 + index);
      });
      if (listIndex == -1) return;
      let listItem = this.$refs[`searchItem_${listIndex}`][0];
      this.$refs.searchList.scrollTo({
        top: listItem.offsetTop - 20,
        behavior: 'smooth'
      });
    },
    getSearchList(type) {
      // 检索列表
      this.$api.getFormList(this.$route.query.fid, 'c3ce0ded58538099a864ed4c877eee73aa5084d3028db91d73d6a5f2391a6610').then(res => {
        if (res.total > 0) {
          let list_s = res.data.map((item, index) => {
            let itemformdata_s = item.formData;
            let itemformat_s = {};
            Object.keys(itemformdata_s).forEach(key => {
              itemformat_s[transformStr3(itemformdata_s[key].alias)] = getformdataList(itemformdata_s[key]);
            });
            item.itemformdata_s = itemformat_s;
            item.initial = makePy(item.itemformdata_s[1].charAt(0))[0].toUpperCase();
            return item;
          });
          this.primarySearchList = list_s.sort((a, b) => {
            return makePy(b.itemformdata_s[1].charAt(0))[0].toUpperCase() < makePy(a.itemformdata_s[1].charAt(0))[0].toUpperCase() ? 1 : -1;
          });
          this.searchList = JSON.parse(JSON.stringify(this.primarySearchList));
          if (this.searchKey) this.changeSearchKey();
        }
      });
    },
    // 获取数据
    changeSearchKey() {
      if (!this.primarySearchList.length) {
        return this.getSearchList('created');
      }
      this.showSearch = true;
      this.searchList = this.primarySearchList.filter(item => {
        return item.itemformdata_s[1].indexOf(this.searchKey) > -1;
      });
    },
    // 宽度
    setWidth() {
      if (window.innerWidth > 880 && window.innerWidth < 1500) {
        this.scale = window.innerWidth / 1500;
      }
      if (window.innerWidth > 880) {
        this.isPc = true;
      }
      this.pcTitleTop = window.innerHeight - 836 * this.scale > 0 ? (window.innerHeight - 836 * this.scale) * 0.5 : 10;
    },
    cancelSearch() {
      this.searchKey = '';
      this.$nextTick(() => {
        this.showSearch = false;
      });
    }
  },
  created() {
    this.setWidth();
    this.doc_width = window.innerWidth;
    this.getData();
    let list2 = ['jquery-1.11.0.min.js', 'pinyin.js'];
    list2.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/360/${item}`;
      document.body.appendChild(oScript);
    });
    let that = this;
    document.body.style.overflow = 'hidden';
  },
  computed: {},
  watch: {
    showSearch(val) {
      if (this.isPc) return;
      if (val && !this.primarySearchList.length) {
        this.getSearchList();
      }
    },
    searchKey(val) {
      if (this.isPc) return;
      this.changeSearchKey();
    }
  }
};